import { Mark } from '@tiptap/core';
import utils from './tiptap-utils';

// Allow for a custom element <w20> in the markup. 
// W20 stands for width 20%.
const Highlight = Mark.create({
    name: 'w20',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'w20',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['w20', HTMLAttributes /* core.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)*/, 0];
    },
    addCommands() {
        return {
            setW20: () => ({ editor, commands }) => {
                utils.selectWord(editor,commands);
                commands.unsetMark("w25")
                return commands.setMark(this.name)
            },
            toggleW20: () => ({ editor, commands }) => {
                console.log('toggleW20')
                utils.selectWord(editor,commands);
                commands.unsetMark("w25")
                return commands.toggleMark(this.name)
            },
            unsetW20: () => ({ editor, commands }) => {
                utils.selectWord(editor,commands);
                return commands.unsetMark(this.name)
            },
        }
    },
    addKeyboardShortcuts() {
        return {};
    },
    addInputRules() {
        return [
        ];
    },
    addPasteRules() {
        return [];
    },
});


export { Highlight, Highlight as default };